"use client";

import type { Location } from "@/lib/types";

interface LocationPickerProps {
  id: string;
  label: string;
  locations: Location[];
  value: number | null;
  onChange: (id: number) => void;
  emptyMessage?: string;
}

export default function LocationPicker({
  id,
  label,
  locations,
  value,
  onChange,
  emptyMessage = "Rezervacija laikinai negalima — nenustatytos vietos.",
}: LocationPickerProps) {
  if (locations.length === 0) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 text-sm text-yellow-800">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
      <select
        id={id}
        required
        value={value ?? locations[0].id}
        onChange={(e) => onChange(Number(e.target.value))}
        className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white"
      >
        {locations.map((loc) => (
          <option key={loc.id} value={loc.id}>
            {loc.name}{loc.surcharge > 0 ? ` (+${loc.surcharge} €)` : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
